angular.module('bbl.directives')
  .directive('talkWidget', [ 'CallManager', TalkWidget ]);

function TalkWidget(CallManager) {
  return {
    restrict: 'E',
    templateUrl: 'talk-widget-template.html',
    scope: { bridge: '=' },
    controller: ['$scope', function($scope) {
      $scope.call = null;

      $scope.close = function() {
        if(!$scope.call) {
          return;
        }

        $scope.call.end();
        $scope.call = null;
      };

      $scope.mute = function(){
        var call = $scope.call;

        call[call.isMute ? 'unmute' : 'mute']();
        call.isMute = !call.isMute;
      };

      $scope.getTitle = function() {
        var call = $scope.call;
        if(call && call.bridge) {

          var bridge = call.bridge, company = bridge.company || '';
          return (bridge.title || bridge.friendly_phone || company.name || company || bridge.friendly_number) || '';
        }
      };

      $scope.dtmf = function(digit) {
        if(!$scope.call || !$scope.call.connected) {
          return;
        }

        $scope.call.dtmf(digit);
      };

      CallManager.sub(CallManager.types.NEWCALL, function(ev, call) {
        call.on(call.types.TERMINATED, $scope.close);
        $scope.call = call;
      });

      $scope.getStatus = function() {
        var call = $scope.call || {},
          connected = call.connected;

        return !connected ? 'Connecting...' : 'Connected '+call.duration;
      };
    }],

    link: function($scope) {}
  };
}



/*****************
 ** WEBPACK FOOTER
 ** ./app/common/directives/talk-widget/talk-widget.controller.js
 ** module id = 182
 ** module chunks = 0
 **/